/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "afabf4cf0a38614aa946cee829f75247288d0e68";
